<template lang="pug">
    div
        h5._300.m-b-md.m-t-md Confirm each product attribute is matched to the correct column in your import file :

        form(id="import-mapper")
            div.row-col.m-b-md
                div.col-xs-6.dark.p-a-md
                    span._500.m-l-sm Core Product Attributes
                div.col-xs-6.dark.p-a-md
                    span._500.m-l-sm Colums in Your Document 

            div.row-col.m-b-md(v-for="attribute in attributes")
                div.col-xs-6.b-a.p-a-sm.p-l-md.dker
                    span.clear._500 {{ attribute.name }}
                
                div.col-xs-6.b-a.p-a-sm
                    div.form-group
                        select.form-control(
                            :disabled="onLoading(loader)"
                            :required="attribute.required",
                            v-model="attribute.mapper",
                        )
                            option(v-bind:value="null") None
                            option(v-for="heading in headings" v-bind:value="heading") {{ toTitleCase(heading) }}

                        ul.m-t-sm.m-l-sm.list-unstyled.text-muted(v-if="getSampleDataByKey(attribute.mapper).length")
                            li(v-for="data in getSampleDataByKey(attribute.mapper)") {{ data }}
</template>

<script>
import { Event } from '../../../event-bus';

export default {
    props: {
        uploadedContent: {
            type: Object,
            required: true,
        },
        importKey: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            attributes: [
                { key: 'product_key', name: 'Product Key', mapper: null },
                { key: 'name', name: 'Name', mapper: null },
                { key: 'code', name: 'Code', mapper: null },
                { key: 'unit_price', name: 'Unit Price', mapper: null },
                { key: 'cost', name: 'Cost', mapper: null },
                { key: 'status', name: 'Status', mapper: null },
                { key: 'description', name: 'Description', mapper: null },
                { key: 'variant_name', name: 'Variant Name', mapper: null },
                { key: 'variant_code', name: 'Variant Code', mapper: null },
                { key: 'variant_cost', name: 'Variant Cost', mapper: null },
                { key: 'variant_price', name: 'Variant Price', mapper: null },
                { key: 'category', name: 'Category', mapper: null },
                { key: 'tags', name: 'Tags', mapper: null },
                { key: 'tags_code', name: 'Tags Code', mapper: null },
                { key: 'outlet_id', name: 'Outlet ID', mapper: null },
            ],
        };
    },

    computed: {
        headings() {
            return this.uploadedContent.headings.filter(h => {
                return typeof h == 'string';
            });
        },

        rows() {
            return this.uploadedContent.rows;
        },

        mapper() {
            let mapper = {};

            this.attributes.forEach(attribute => {
                mapper[attribute.key] = attribute.mapper;
            });

            return mapper;
        },
        loader() {
            return 'importing item';
        },
    },

    mounted() {
        this.autoMappingColumn();
    },

    methods: {
        autoMappingColumn() {
            this.attributes.forEach((attr, idx) => {
                if (this.isHeadingsExists(attr.key)) {
                    attr.mapper = attr.key;
                }
            });
        },

        isHeadingsExists(heading) {
            return !_.isUndefined(this.headings.find(h => h == heading));
        },

        /**
         * @param  {String} key
         * @return {Array}
         */
        getSampleDataByKey(key) {
            if (_.isNull(key)) {
                return [];
            }

            return this.rows
                .filter(row => {
                    return !_.isNull(row[key]) && row[key] != '';
                })
                .map(row => row[key])
                .splice(0, 3);
        },

        submit() {
            this.startLoading(this.loader);

            let api = Laroute.route('franchise.inventory.item.validate_data', {
                importKey: this.importKey,
            });

            axios
                .post(api, this.mapper)
                .then(res => {
                    Event.$emit('validating-data', this.mapper);
                })
                .catch(err => {
                    this.endLoading(this.loader);
                    this.showApiError(err);
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/item/import-item-mapper.vue